import * as React from 'react'
import styled from 'styled-components'

type ICardWrapper = {
  padding?: string
}

const CardWrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: #fff;
  margin-bottom: 24px;
  border-radius: ${(props) => props.theme.border.radius || '6px'};
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  font-size: 0.95rem;
  overflow: hidden;

  .card-header {
    font-size: 1.125em;
    font-weight: 600;
    padding: 12px 18px;
    border-bottom: 1px solid ${(props) => props.theme.border.color};
  }

  .card-footer {
    padding: 12px 18px;
    border-top: 1px solid ${(props) => props.theme.border.color};
    border-bottom-left-radius: ${(props) => props.theme.border.radius || '6px'};
    border-bottom-right-radius: ${(props) =>
      props.theme.border.radius || '6px'};
    transition: all 0.2s ease-in;

    &.clickable:hover {
      cursor: pointer;

      &:hover {
        background-color: ${(props) => props.theme.button.info.bgColor};
      }
    }
  }
`

const CardContent = styled.div<ICardWrapper>`
  padding: ${(props) => (props.padding ? props.padding : '18px')};
`

interface ICard extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
  heading?: React.ReactNode
  padding?: string
  footer?: React.ReactNode
  footerclickable?: boolean
}

export function Card({
  children,
  heading,
  footer,
  footerclickable,
  padding,
  ...rest
}: ICard) {
  return (
    <CardWrapper {...rest}>
      {heading && <div className="card-header">{heading}</div>}
      <CardContent padding={padding || '18px'}>{children}</CardContent>

      {footer ? (
        <div className={`card-footer${footerclickable ? ' clickable' : ''}`}>
          {footer}
        </div>
      ) : (
        ''
      )}
    </CardWrapper>
  )
}
